import React, { Suspense } from 'react';

const LazySuspense = props => (
  <Suspense fallback={<div>Lazyloading...</div>}>{props.children}</Suspense>
);

export default LazySuspense;
